<template>
    <nav aria-label="Progress" class="hidden min-w-full px-3 py-6 mt-8 bg-zinc-50 rounded-2xl profile-completion md:inline-block">
        <div>
            <div class="cursor-pointer" @click.prevent="openBrowseMore =! openBrowseMore">
                <div class="flex justify-between mb-1">
                    <span class="text-base font-medium text-powder-800 dark:text-white">Profile <ChevronDownIcon
                            class="inline-block w-5 h-5 hover:text-blue"></ChevronDownIcon></span>
                    <span class="text-sm font-medium text-powder-800 dark:text-white">{{ percentCompleted }}%</span>
                </div>
                <div class="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                    <div class="bg-powder-600 h-2.5 rounded-full" :style="{ width: percentCompleted + '%' }"></div>
                </div>

            </div>
            <ol  v-if="openBrowseMore" class="pt-4 overflow-hidden" role="list">
                <li v-for="section in sections" :key="section.name" class="relative pb-5">
                    <div aria-hidden="true"
                         class="absolute top-4 left-3 -ml-px mt-0.5 h-full w-0.5 bg-gray-300 step-connect"></div>
                    <a :href="section.url"
                       class="relative flex items-start text-gray-700 group hover:text-powder-600">
                    <span class="flex items-center h-9">
                      <span v-if="tags.includes(section.tag)"
                            class="relative z-10 flex items-center justify-center w-6 h-6 rounded-full bg-powder-500 group-hover:bg-powder-600">
                        <CheckIcon class="w-3 h-3 text-white"></CheckIcon> 
                      </span>
                      <span v-else
                            class="relative z-10 flex items-center justify-center w-6 h-6 text-gray-300 bg-white border rounded-full border-clay-500 group-hover:bg-powder-600 hover:text-white">
                        <span class="bg-transparent rounded-full group-hover:bg-powder-600"></span>
                       
                      </span>
                    </span>
                        <span class="flex flex-col min-w-0 ml-4">
                        <span class="my-1 font-medium text-md ">{{ section.name }}</span>
                        
                        <span v-for="action in section.actions" :key="action.name" :class="tags.includes(action.tag) ? 'text-powder-950   font-semibold' : 'text-powder-800'"
                              class="text-sm">
                             {{ action.name }}
                        </span>
                           
                            <span v-for="action in section.actions" :key="action.name" :class="tags.includes(action.tag) ? 'text-powder-950  font-semibold' : 'text-powder-800  font-semibold'"
                                  class="text-sm">
                        </span>
                    </span>
                    </a>
                </li>
            </ol>
        </div>
    </nav>

</template>

<script lang="ts" setup>
// @ts-ignore


import {computed, defineProps, onMounted, Ref, ref} from "vue";
import {store} from "@/store";
import {CheckIcon, ChevronDownIcon, ChevronUpIcon, SparklesIcon} from '@heroicons/vue/20/solid';
import {client} from "@/shared";
import {GetUserMetadata, UserMetadata} from "@/dtos";
import _ from "lodash";


const tags = ref([]);
const sections = ref([]);
const openBrowseMore = ref(true);
const completedTags = computed(() => {
    let sectionTags: any[] = [];
    sections.value.forEach((section: any) => {
        sectionTags.push(section.tag);
    })
    let notCompleted = _.difference(sectionTags, tags.value).length;
    let completed = 7 - notCompleted;
    return completed;
});

const percentCompleted = computed(() => Math.floor((completedTags.value * 100) / 7));

onMounted(async () => {
    sections.value = store.profileProgressSection;

    await client.get<UserMetadata>(new GetUserMetadata())
        .then(response => {
            tags.value = response.tags
        });
});
</script>